export default __webpack_public_path__ + "static/mokku-fbc3cc3bd6a091edcdc601b42001e4d9.png";